var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLiveTracking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "live-tracking"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5002 18.6669L19.162 20.3287C20.9959 18.8311 22.1667 16.5523 22.1667 14C22.1667 11.4477 20.9959 9.16891 19.162 7.67133L17.5002 9.3331C18.917 10.3974 19.8333 12.0917 19.8333 14C19.8333 15.9084 18.917 17.6027 17.5002 18.6669Z",
    fill: "url(#paint0_radial_0_32)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4726 23.6392L20.8185 21.9851C23.0717 20.0593 24.5 17.1965 24.5 14C24.5 10.8036 23.0717 7.94071 20.8185 6.01487L22.4725 4.36079C25.1462 6.71266 26.8333 10.1593 26.8333 14C26.8333 17.8407 25.1462 21.2874 22.4726 23.6392Z",
    fill: "url(#paint1_radial_0_32)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.16667 14C1.16667 17.8407 2.85383 21.2874 5.52744 23.6392L7.18152 21.9851C4.92831 20.0593 3.5 17.1965 3.5 14C3.5 10.8036 4.92831 7.94071 7.18152 6.01487L5.52745 4.36079C2.85383 6.71266 1.16667 10.1593 1.16667 14Z",
    fill: "url(#paint2_radial_0_32)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16667 14C8.16667 15.9084 9.08304 17.6027 10.4997 18.6669L8.83798 20.3287C7.00415 18.8311 5.83333 16.5523 5.83333 14C5.83333 11.4477 7.00415 9.16891 8.83799 7.67133L10.4998 9.3331C9.08304 10.3974 8.16667 12.0917 8.16667 14Z",
    fill: "url(#paint3_radial_0_32)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 17.5C15.933 17.5 17.5 15.933 17.5 14C17.5 12.067 15.933 10.5 14 10.5C12.067 10.5 10.5 12.067 10.5 14C10.5 15.933 12.067 17.5 14 17.5Z",
    fill: "url(#paint4_radial_0_32)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_0_32",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14 14.5919) rotate(90) scale(11.0833 14.756)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3370E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F5F4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_0_32",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14 14.5919) rotate(90) scale(11.0833 14.756)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3370E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F5F4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_0_32",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14 14.5919) rotate(90) scale(11.0833 14.756)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3370E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F5F4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_0_32",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14 14.5919) rotate(90) scale(11.0833 14.756)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3370E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F5F4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_0_32",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14 14.5919) rotate(90) scale(11.0833 14.756)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3370E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F5F4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveTracking);
export default __webpack_public_path__ + "static/media/live-tracking.b6720475eb7cfc0dfaecd2352c762afa.svg";
export { ForwardRef as ReactComponent };